import React from "react";
import Box from "@mui/material/Box";
import MuiAlert from "@mui/material/Alert";
import Typography from "@mui/material/Typography";

export function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 0 }}>
          <Typography component={"span"}>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

export function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export const getPath = (x, y, width, height) => `M${x},${y + height}
  C${x + width / 3},${y + height} ${x + width / 2},${y + height / 3} ${
    x + width / 2
  }, ${y}
  C${x + width / 2},${y + height / 3} ${x + (2 * width) / 3},${y + height} ${
    x + width
  }, ${y + height}
  Z`;

export const TriangleBar = (props) => {
  const { fill, x, y, width, height } = props;

  return <path d={getPath(x, y, width, height)} stroke="none" fill={fill} />;
};

export const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function isValid(value, expanded) {
  if (expanded === "panel3") {
    if (value === ":") {
      alert("Invalid time. Please enter a correct form of time");
      return false;
    }
    var time = value.split(":");
    if (time[1].length > 2 || parseInt(time[1]) >= 60) {
      alert("Invalid time. Please enter a correct form of time");
      return false;
    }
    if (time[1].length > 2) {
      alert("Invalid time. Please enter a correct form of time");
      return false;
    }
    for (var i in time) {
      if (typeof time[i] != "string") return false; // we only process strings!
      return (
        !isNaN(time[i]) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
        !isNaN(parseFloat(time[i]))
      ); // ...and ensure strings of whitespace fail
    }
  }
  if (expanded === "panel2" || expanded === "panel1") {
    if (typeof value.toString() != "string") return false;
    return !isNaN(value.toString()) && !isNaN(parseFloat(value.toString()));
  }
}

export const isEmpty = (value) => {
  if (value.length <= 0) {
    return true;
  }
  return false;
};

const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;

export function isEmail(value) {
  if (value.match(emailRegex)) {
    return true;
  }
  return false;
}

export function unicodeToEmoji(text) {
  return text.replace(/U\+([0-9A-F]{4,6})/gi, (match, hex) => {
    const codePoint = parseInt(hex, 16);
    return String.fromCodePoint(codePoint);
  });
}

export function replaceEmojisWithUnicode(text) {
  return Array.from(text)
    .map((char) => {
      const code = char.codePointAt(0);
      // Emojis are generally code points > 0x1F000
      if (code >= 0x1f000 || isEmojiExtra(char)) {
        return `U+${code.toString(16).toUpperCase()}`;
      }
      return char;
    })
    .join("");
}

// Helper: include some other common emoji ranges
function isEmojiExtra(char) {
  const code = char.codePointAt(0);
  return (
    // Dingbats
    (code >= 0x2700 && code <= 0x27bf) ||
    // Misc Symbols
    (code >= 0x2600 && code <= 0x26ff) ||
    // Enclosed Alphanumerics
    (code >= 0x24c2 && code <= 0x24ff)
  );
}

export function getVideoMeta(file) {
  return new Promise((resolve) => {
    const video = document.createElement("video");
    video.preload = "metadata";
    video.onloadedmetadata = () => {
      resolve({
        width: video.videoWidth,
        height: video.videoHeight,
        duration: Math.round(video.duration),
      });
      URL.revokeObjectURL(video.src);
    };
    video.src = URL.createObjectURL(file);
  });
}
